/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			var latest = $('.js-news-latest-year').text();
			var earliest = $('.js-news-earliest-year').text();
			const optionVal = (_num) => {
				if(location.pathname.match(/\d{4}/)){
					// 文字列に正規表現4桁数値が含まれていたら
					return location.pathname.replace(location.pathname.match(/\d{4}/)[0], _num);
				} else {
					// 文字列に正規表現4桁数値が含まれて無かったら
					return location.pathname + _num + '/';
				}
			};
			// optionを追加
			let optionText = '最新';
			if(location.pathname.split('/')[1] === 'en') {
				optionText = 'Latest';
			}
			let newsVal;
			if(location.pathname.match(/\d{4}/)){
				// 文字列に正規表現4桁数値が含まれていたら
				newsVal = location.pathname.replace(location.pathname.match(/\d{4}/)[0]+'/', '');
			} else {
				// 文字列に正規表現4桁数値が含まれて無かったら
				newsVal = location.pathname;
			}
			$('.js-news-yearList').append($('<option>').html(optionText).val(newsVal));
			for(var i =latest; i>=earliest; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(optionVal(i)));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(location.pathname);
			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = $(this).val();
			});
		}
	};
	newsYearList();

})(window.jQuery, window.FUNCTIONS);
